module.exports = __webpack_public_path__ + "assets/images/project/head/P_V_Sindhu.jpg?v=da484cb7";